import React, { ReactElement } from 'react';
import { Button } from '../../../../components/UISignatue/Button';
import { Container, ContainerButton } from './styles';
import { ArrowRight, Refresh } from './svgs';

// CONTEXT
import { useRetentionSignature } from '../../../../hooks/RetentionSignatureContext';

const RetentionFooter = (props: any): ReactElement => {
  const { currentStep, nextStep, nextStepDisabled = false, loading = false }: any = props;

  const { errorSignature } = useRetentionSignature();

  const nextDescription = () => {
    switch (currentStep) {
      case 1:
        return 'Começar assinatura';
      case 2:
        return 'Aceitar os termos';
      case 5:
        return 'Continuar';
      default:
        return null;
    }
  };

  return (
    <>
      {currentStep == 1 || currentStep == 2 || currentStep == 5 ? (
        <Container className={currentStep > 1 ? ' fixed ' : 'background'}>
          <ContainerButton>
            <Button
              black
              big
              spaced
              onClick={nextStep}
              iconRight={errorSignature ? Refresh : ArrowRight}
              {...{ disabled: nextStepDisabled || loading }}
            >
              {loading ? 'Carregando...' : nextDescription()}
            </Button>
          </ContainerButton>
        </Container>
      ) : (
        ''
      )}
    </>
  );
};

export default RetentionFooter;
